// dependencies
import { List, Map, fromJS } from "immutable";

/*

    This will store our user data. It also deals with searching our users
    and displaying those search results.

    users {Map} :: user information. the format for this will be a map with
    the key being the userid and the value another map with the keys: name,
    _id, dataFields. the dataFields key is yet another map with key being
    the fieldId and value being a map with keys value, fieldName. EX:

    users: {
        USERID : {
            _id         : {String},
            name        : {String},
            dataFields  : {
                FIELDID     : {
                    value       : {String},
                    fieldName   : {String}
                }
            }
        }
    }

*/

const initialState = Map({
	_currentQuery: Map({
		currentPage: 0,
		pageCount: 0,
		letter: "",
		query: "",
		isFetching: false,
	}),

	// store the last search so we can call a 'redo'
	lastSearch: null,

	users: Map(),
	directoryList: List(),

	userLabelCounts: Map(),

	userIds: List(),

	personInputSearch: Map(),
});

export default function users(state = initialState, action) {
	switch (action.type) {
		case "USERS:SEARCH@INIT": {
			return state.withMutations((mutable) => {
				mutable.setIn(["lastSearch"], {
					...action,
					type: action.type.split("@")[0],
				});
				mutable.setIn(["_currentQuery", "isFetching"], true);
			});
		}

		case "USERS:SEARCH_SELECTION@INIT": {
			return state.withMutations((mutable) => {
				mutable.setIn(["lastSearch"], {
					...action,
					type: action.type.split("@")[0],
				});
				mutable.setIn(["_currentQuery", "isFetching"], true);
			});
		}

		case "USERS:REMOVE_PENDING":
		case "USERS:SEARCH@FAIL": {
			return state.setIn(["_currentQuery", "isFetching"], true);
		}

		case "USERS:REMOVE_COMPLETE": {
			return state.setIn(["_currentQuery", "isFetching"], false);
		}

		case "USERS:SEARCH@SUCCESS":
		case "USERS:SEARCH_SELECTION@SUCCESS": {
			return state.withMutations((nest) => {
				nest.setIn(["_currentQuery", "isFetching"], false);
				nest.setIn(["_currentQuery", "query"], action.query);
				nest.setIn(["_currentQuery", "letter"], action.letter);
				nest.setIn(["_currentQuery", "currentPage"], action.page);
			});
		}

		case "USERS:PARSE_SEARCH": {
			return state.withMutations((nest) => {
				nest.set("companyBillingAdmins", action.companyBillingAdmins);
				nest.set("users", action.userMap);
				nest.set("userLabelCounts", action.userCounts);
				nest.set("directoryList", action.userDirectoryOrder);
				nest.setIn(["_currentQuery", "pageCount"], action.pageCount);
			});
		}

		case "USERS:PARSE_ALL": {
			const userIds = action.data.users.sort((a, b) => {
				const texta = a.name;
				const textb = b.name;
				return texta < textb ? -1 : texta > textb ? 1 : 0; // eslint-disable-line no-nested-ternary
			});

			const userMap = {};
			action.data.users.forEach((user) => {
				userMap[user.id] = user;
			});

			return state.withMutations((nest) => {
				nest.set("users", fromJS(userMap));
				nest.set("userIds", fromJS(userIds));
			});
		}

		case "USERS:PARSE_ONE": {
			return state.setIn(["users", action.userId], fromJS(action.user));
		}

		case "USERS:GETSINGLE@SUCCESS": {
			return state.setIn(["users", action.request.props.userID], action.response);
		}

		case "USERS:SEARCH.INPUT@SUCCESS": {
			return state.setIn(["personInputSearch", action.request.props.query], action.response);
		}

		default: {
			return state;
		}
	}
}
